import { NgModule } from '@angular/core';
import { SplitButtonComponent } from './split-button.component';
import { DropdownModule } from '@circe/dropdown';
import { CommonModule } from '@angular/common';
import { KeyboardEmitterModule } from '@circe/event-controls';
import { EventsModule, ToolModule } from '@circe/core';

@NgModule({
  declarations: [SplitButtonComponent],
  imports: [
    CommonModule,
    DropdownModule,
    KeyboardEmitterModule,
    ToolModule.forChild(),
    EventsModule.forChild()
  ],
  exports: [SplitButtonComponent]
})
export class SplitButtonModule {}
